import Vue from 'vue';

import { FmvToggle } from 'fmv-layout';

import 'fmv-layout/dist/fmv-layout.css';

Vue.directive('FmvToggle', FmvToggle);
